// import { MatPaginatorIntl } from '@angular/material';
import {MatPaginatorModule, MatPaginatorIntl} from '@angular/material/paginator';

export function CustomPaginator() {
  const customPaginatorIntl = new MatPaginatorIntl();

  customPaginatorIntl.itemsPerPageLabel = 'Registros por Página:';
  customPaginatorIntl.nextPageLabel = 'Página Siguiente';
  customPaginatorIntl.previousPageLabel = 'Página Anterior';
  customPaginatorIntl.getRangeLabel = (page, size, length) => ((page*size)+size > length ? (page*size)+size - ((page*size)+size - length) : (page*size)+size) + ' de ' + length;

  return customPaginatorIntl;
}
